import { createAction } from 'redux-actions'
import * as constants from './constants'

export const googleOauthAccept = createAction(constants.GOOGLE_OAUTH_ACCEPT)
export const googleOauthAcceptSuccess = createAction(constants.GOOGLE_OAUTH_ACCEPT_SUCCESS)
export const googleOauthAcceptFailure = createAction(constants.GOOGLE_OAUTH_ACCEPT_FAILURE)

export const microsoftOauthAccept = createAction(constants.MICROSOFT_OAUTH_ACCEPT)
export const microsoftOauthAcceptSuccess = createAction(constants.MICROSOFT_OAUTH_ACCEPT_SUCCESS)
export const microsoftOauthAcceptFailure = createAction(constants.MICROSOFT_OAUTH_ACCEPT_FAILURE)

export const fetchCalendarStatus = createAction(constants.FETCH_CALENDAR_STATUS)
export const fetchCalendarStatusPending = createAction(constants.FETCH_CALENDAR_STATUS_PENDING)
export const fetchCalendarStatusSuccess = createAction(constants.FETCH_CALENDAR_STATUS_SUCCESS)
export const fetchCalendarStatusFailure = createAction(constants.FETCH_CALENDAR_STATUS_FAILURE)

export const fetchGoogleCalendars = createAction(constants.FETCH_GOOGLE_CALENDARS)
export const fetchGoogleCalendarsPending = createAction(constants.FETCH_GOOGLE_CALENDARS_PENDING)
export const fetchGoogleCalendarsSuccess = createAction(constants.FETCH_GOOGLE_CALENDARS_SUCCESS)
export const fetchGoogleCalendarsFailure = createAction(constants.FETCH_GOOGLE_CALENDARS_FAILURE)

export const fetchMicrosoftCalendars = createAction(constants.FETCH_MICROSOFT_CALENDARS)
export const fetchMicrosoftCalendarsPending = createAction(constants.FETCH_MICROSOFT_CALENDARS_PENDING)
export const fetchMicrosoftCalendarsSuccess = createAction(constants.FETCH_MICROSOFT_CALENDARS_SUCCESS)
export const fetchMicrosoftCalendarsFailure = createAction(constants.FETCH_MICROSOFT_CALENDARS_FAILURE)

export const fetchMicrosoftAdminConsent = createAction(constants.FETCH_MICROSOFT_ADMIN_CONSENT)
export const fetchMicrosoftAdminConsentPending = createAction(constants.FETCH_MICROSOFT_ADMIN_CONSENT_PENDING)
export const fetchMicrosoftAdminConsentSuccess = createAction(constants.FETCH_MICROSOFT_ADMIN_CONSENT_SUCCESS)
export const fetchMicrosoftAdminConsentFailure = createAction(constants.FETCH_MICROSOFT_ADMIN_CONSENT_FAILURE)

export const fetchMicrosoftManagedCalendars = createAction(constants.FETCH_MICROSOFT_MANAGED_CALENDARS)
export const fetchMicrosoftManagedCalendarsPending = createAction(constants.FETCH_MICROSOFT_MANAGED_CALENDARS_PENDING)
export const fetchMicrosoftManagedCalendarsSuccess = createAction(constants.FETCH_MICROSOFT_MANAGED_CALENDARS_SUCCESS)
export const fetchMicrosoftManagedCalendarsFailure = createAction(constants.FETCH_MICROSOFT_MANAGED_CALENDARS_FAILURE)

export const disconnectMicrosoftAdminConsent = createAction(constants.DISCONNECT_MICROSOFT_ADMIN_CONSENT)
export const disconnectMicrosoftAdminConsentPending = createAction(constants.DISCONNECT_MICROSOFT_ADMIN_CONSENT_PENDING)
export const disconnectMicrosoftAdminConsentSuccess = createAction(constants.DISCONNECT_MICROSOFT_ADMIN_CONSENT_SUCCESS)
export const disconnectMicrosoftAdminConsentFailure = createAction(constants.DISCONNECT_MICROSOFT_ADMIN_CONSENT_FAILURE)

export const microsoftAdminManagedAccept = createAction(constants.MICROSOFT_ADMIN_MANAGED_ACCEPT)
export const microsoftAdminManagedAcceptSuccess = createAction(constants.MICROSOFT_ADMIN_MANAGED_ACCEPT_SUCCESS)
export const microsoftAdminManagedAcceptFailure = createAction(constants.MICROSOFT_ADMIN_MANAGED_ACCEPT_FAILURE)

export const updateGoogleCalendar = createAction(constants.UPDATE_GOOGLE_CALENDAR)
export const updateGoogleCalendarPending = createAction(constants.UPDATE_GOOGLE_CALENDAR_PENDING)
export const updateGoogleCalendarSuccess = createAction(constants.UPDATE_GOOGLE_CALENDAR_SUCCESS)
export const updateGoogleCalendarFailure = createAction(constants.UPDATE_GOOGLE_CALENDAR_FAILURE)

export const updateMicrosoftCalendar = createAction(constants.UPDATE_MICROSOFT_CALENDAR)
export const updateMicrosoftCalendarPending = createAction(constants.UPDATE_MICROSOFT_CALENDAR_PENDING)
export const updateMicrosoftCalendarSuccess = createAction(constants.UPDATE_MICROSOFT_CALENDAR_SUCCESS)
export const updateMicrosoftCalendarFailure = createAction(constants.UPDATE_MICROSOFT_CALENDAR_FAILURE)

export const disconnectGoogleCalendar = createAction(constants.DISCONNECT_GOOGLE_CALENDAR)
export const disconnectGoogleCalendarPending = createAction(constants.DISCONNECT_GOOGLE_CALENDAR_PENDING)
export const disconnectGoogleCalendarSuccess = createAction(constants.DISCONNECT_GOOGLE_CALENDAR_SUCCESS)
export const disconnectGoogleCalendarFailure = createAction(constants.DISCONNECT_GOOGLE_CALENDAR_FAILURE)

export const disconnectMicrosoftCalendar = createAction(constants.DISCONNECT_MICROSOFT_CALENDAR)
export const disconnectMicrosoftCalendarPending = createAction(
  constants.DISCONNECT_MICROSOFT_CALENDAR_PENDING
)
export const disconnectMicrosoftCalendarSuccess = createAction(
  constants.DISCONNECT_MICROSOFT_CALENDAR_SUCCESS
)
export const disconnectMicrosoftCalendarFailure = createAction(
  constants.DISCONNECT_MICROSOFT_CALENDAR_FAILURE
)

export const fetchGoogleScopes = createAction(constants.FETCH_GOOGLE_SCOPES)
export const fetchGoogleScopesPending = createAction(constants.FETCH_GOOGLE_SCOPES_PENDING)
export const fetchGoogleScopesSuccess = createAction(constants.FETCH_GOOGLE_SCOPES_SUCCESS)
export const fetchGoogleScopesFailure = createAction(constants.FETCH_GOOGLE_SCOPES_FAILURE)

export const fetchMeetingSettings = createAction(constants.FETCH_MEETING_SETTINGS)
export const fetchMeetingSettingsPending = createAction(constants.FETCH_MEETING_SETTINGS_PENDING)
export const fetchMeetingSettingsSuccess = createAction(constants.FETCH_MEETING_SETTINGS_SUCCESS)
export const fetchMeetingSettingsFailure = createAction(constants.FETCH_MEETING_SETTINGS_FAILURE)

export const debounceUpdateMeetingSettings = createAction(constants.DEBOUNCE_UPDATE_MEETING_SETTINGS)
export const updateMeetingSettings = createAction(constants.UPDATE_MEETING_SETTINGS)
export const updateMeetingSettingsPending = createAction(constants.UPDATE_MEETING_SETTINGS_PENDING)
export const updateMeetingSettingsSuccess = createAction(constants.UPDATE_MEETING_SETTINGS_SUCCESS)
export const updateMeetingSettingsFailure = createAction(constants.UPDATE_MEETING_SETTINGS_FAILURE)

export const deleteMeetingType = createAction(constants.DELETE_MEETING_TYPE)
export const deleteMeetingTypePending = createAction(constants.DELETE_MEETING_TYPE_PENDING)
export const deleteMeetingTypeSuccess = createAction(constants.DELETE_MEETING_TYPE_SUCCESS)
export const deleteMeetingTypeFailure = createAction(constants.DELETE_MEETING_TYPE_FAILURE)

export const updateMeetingType = createAction(constants.UPDATE_MEETING_TYPE)
export const updateMeetingTypePending = createAction(constants.UPDATE_MEETING_TYPE_PENDING)
export const updateMeetingTypeSuccess = createAction(constants.UPDATE_MEETING_TYPE_SUCCESS)
export const updateMeetingTypeFailure = createAction(constants.UPDATE_MEETING_TYPE_FAILURE)

export const fetchMeetingTypes = createAction(constants.FETCH_MEETING_TYPES)
export const fetchMeetingTypesPending = createAction(constants.FETCH_MEETING_TYPES_PENDING)
export const fetchMeetingTypesSuccess = createAction(constants.FETCH_MEETING_TYPES_SUCCESS)
export const fetchMeetingTypesFailure = createAction(constants.FETCH_MEETING_TYPES_FAILURE)

export const fetchCalendlyMeetingTypes = createAction(constants.FETCH_CALENDLY_MEETING_TYPES)
export const fetchCalendlyMeetingTypesPending = createAction(constants.FETCH_CALENDLY_MEETING_TYPES_PENDING)
export const fetchCalendlyMeetingTypesSuccess = createAction(constants.FETCH_CALENDLY_MEETING_TYPES_SUCCESS)
export const fetchCalendlyMeetingTypesFailure = createAction(constants.FETCH_CALENDLY_MEETING_TYPES_FAILURE)

export const updateMeetingSettingsNewAppointments = createAction(
  constants.UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS
)
export const updateMeetingSettingsNewAppointmentsPending = createAction(
  constants.UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_PENDING
)
export const updateMeetingSettingsNewAppointmentsSuccess = createAction(
  constants.UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_SUCCESS
)
export const updateMeetingSettingsNewAppointmentsFailure = createAction(
  constants.UPDATE_MEETING_SETTINGS_NEW_APPOINTMENTS_FAILURE
)

export const shareCalendar = createAction(constants.SHARE_CALENDAR)
export const shareCalendarSuccess = createAction(constants.SHARE_CALENDAR_SUCCESS)
export const shareCalendarFailure = createAction(constants.SHARE_CALENDAR_FAILURE)

export const fetchConnectedCalendars = createAction(constants.FETCH_CONNECTED_CALENDARS)
export const fetchConnectedCalendarsPending = createAction(constants.FETCH_CONNECTED_CALENDARS_PENDING)
export const fetchConnectedCalendarsSuccess = createAction(constants.FETCH_CONNECTED_CALENDARS_SUCCESS)
export const fetchConnectedCalendarsFailure = createAction(constants.FETCH_CONNECTED_CALENDARS_FAILURE)

export const shareRoutedCalendar = createAction(constants.SHARE_ROUTED_CALENDAR)
export const shareRoutedCalendarSuccess = createAction(constants.SHARE_ROUTED_CALENDAR_SUCCESS)
export const shareRoutedCalendarFailure = createAction(constants.SHARE_ROUTED_CALENDAR_FAILURE)

export const openedMeetingEmailModal = createAction(constants.OPENED_MEETING_EMAIL_MODAL)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/meetings/actions.js